<mat-card>
  <h2 translate>purchases.title</h2>
  <span>{{ 'purchases.text' | translate }} </span>
  <form [formGroup]="purchasesDataForm">
    <mat-grid-list cols="12" rowHeight="90px">
      <mat-grid-tile colspan="4">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="establishment"
          [id]="'establishment'"
          [dataInput]="establishmentsList"
          [placeholder]="'purchases.establishment'"
          [isRequired]="true"
          [showErrors]="purchasesDataForm?.controls?.establishment?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="8"></mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>purchases.contractNumber</mat-label>
          <input id="contractNum" formControlName="contractNum" matInput autocomplete="off" />
          <mat-error *ngIf="purchasesDataForm.controls.contractNum.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>purchases.nifnie</mat-label>
          <input id="nifNie" formControlName="nifNie" matInput type="text" maxlength="10" autocomplete="off" />
          <mat-error *ngIf="purchasesDataForm.controls.nifNie.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              !purchasesDataForm.controls.nifNie.hasError('required') &&
              purchasesDataForm.controls.nifNie.hasError('dniInvalid')
            "
            translate
          >
            field.incorrect
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>purchases.purchaseImport</mat-label>
          <input
            #purchaseImport
            id="purchaseImport"
            formControlName="purchaseImport"
            matInput
            (keypress)="numberOnly($event, purchaseImport)"
            (blur)="transformAmount($event, purchaseImport)"
            autocomplete="off"
          />
          <mat-error *ngIf="purchasesDataForm.controls.purchaseImport.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
  <mat-checkbox
    id="chkFractionalOperations"
    name="chkFractionalOperations"
    *ngIf="hasAttributionInstallmentsPayment"
    [disabled]="!hasAttributionRegularPayment"
    [(ngModel)]="chkFractionalOp"
    (ngModelChange)="isFractionalOperation()"
  >
    <mat-label translate>purchases.fractionalOperation</mat-label>
  </mat-checkbox>
  <p *ngIf="chkFractionalOp" class="padding-top"><strong translate>purchases.fractionalPayments</strong></p>
  <form [formGroup]="fractionalOperationForm" *ngIf="chkFractionalOp">
    <mat-grid-list cols="12" rowHeight="90px">
      <mat-grid-tile colspan="4">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="tariffCode"
          [id]="'tariffCode'"
          [dataInput]="tariffCodeList"
          [placeholder]="'purchases.tariffCode'"
          [isRequired]="true"
          [showErrors]="fractionalOperationForm?.controls?.tariffCode?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="monthlyPayments"
          [id]="'monthlyPayments'"
          [dataInput]="monthlyPaymentsList"
          [placeholder]="'purchases.monthlyPayments'"
          [isRequired]="true"
          [showErrors]="fractionalOperationForm?.controls?.monthlyPayments?.errors"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>purchases.description</mat-label>
          <input
            id="purchaseDescription"
            #purchaseDescription
            formControlName="description"
            matInput
            maxlength="20"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-hint align="end">{{ purchaseDescription.value.length }} / 20</mat-hint>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>
<div fxLayout="row" fxLayoutAlign="end center">
  <button id="btnCancel" mat-stroked-button color="accent" class="button-margin" (click)="cancelClick()">
    {{ 'button.cancel' | translate | uppercase }}
  </button>
  <button
    id="btnAccept"
    mat-flat-button
    color="accent"
    class="button-margin"
    (click)="acceptClick()"
    [disabled]="!isBtnEnabled"
  >
    {{ 'button.accept' | translate | uppercase }}
  </button>
</div>
